import './App.css';
import { useEffect, useState } from 'react'
import StartScreen from './components/startScreen.jsx'
import EndScreen from './components/endScreen.jsx'
import GameScreen from './components/gameScreen.jsx'
import { VolumeOff, VolumeUp } from '@material-ui/icons';
import ReactGA from 'react-ga';


const parse = require('csv-parse')


const App = () => {

  ReactGA.initialize('UA-214460310-1');
  ReactGA.pageview(window.location.pathname + window.location.search);

  const [score, setScore] = useState(0);
  const [shotCount,setShotCount] = useState({
    red: 0,
    yellow: 0,
    orange: 0,
  })
  const [scores,setScores] = useState({
    antibioticsWasted: {
      red: 0,
      yellow: 0,
      orange: 0,
    },
    unidentifiedBugs: {
      hit: 0,
      ignored: 0
    }
  })
  const [soundOn,setSoundOn] = useState(true)

  const [fired, setFired] = useState(false);
  const [rotating, setRotating] = useState(false);
  const [gameState, setGameState] = useState(0)
  const [timerStart,setTimerStart] = useState(0)
  const [timer,setTimer] = useState(0)
  const [messagePool,setMessagePool] = useState(0)
  const [bugLevels, setBugLevels] = useState({
    red: 0,
    yellow: 0,
    orange: 0
  });

  const startGame = () => {
    setGameState(1)
    setScore(0)
    setTimerStart(Date.now())
    setBugLevels({
      red: 0,
      yellow: 0,
      orange: 0
    })
    setShotCount({
      red: 0,
      yellow: 0,
      orange: 0,
    })
    setScores({
      antibioticsWasted: {
        red: 0,
        yellow: 0,
        orange: 0,
      },
      unidentifiedBugs: {
        hit: 0,
        ignored: 0
      }
    })
  }

  const restartGame = () => {
    setGameState(0)
    setScore(0)
    setBugLevels({
      red: 0,
      yellow: 0,
      orange: 0
    })
  }

  const displayGameState = (gameState) => {
    if (gameState === 0) {
      return <StartScreen messagePool={messagePool} startGame={startGame} />
    } else
    if (gameState === 1) {
      return <GameScreen shotCount={shotCount} setShotCount={setShotCount}  scores={scores} setScores={setScores} soundOn={soundOn} bugLevels={bugLevels} setBugLevels={setBugLevels} timer={timer} score={score} setScore={setScore} fired={fired} setFired={setFired} rotating={rotating} setRotating={setRotating} />
    } else {
      return <EndScreen scores={scores} messagePool={messagePool} score={score} restartGame={restartGame} />
    }
  }

  useEffect(() => {
    let timeout
    let timerLength = 60
    if (gameState === 1 && timerLength-(Date.now()-timerStart)/1000 <= 0) {
      setGameState(2)
    } else 
    if (gameState === 1) {
      timeout = setTimeout(() => {
        setTimer(timerLength-(Date.now()-timerStart)/1000)
      }, 100);
    }
    
    return () => clearTimeout(timeout);

  },[timerStart,timer,setTimer,gameState])


  useEffect(() => {
    if (!messagePool) {

      const loadMessageData = (parser,data) => {
        data.split("\n").forEach(d => 
          parser.write(d)
        )
      }
        
      let messages = {}
      const parser = parse({
        delimiter: ','
      })

      parser.on('readable', function(){
        let record
        // eslint-disable-next-line
        while (record = parser.read()) {

          let type = record[0]
          if (!messages[`${type}Messages`]){
            messages[`${type}Messages`] = []
          }
          messages[`${type}Messages`].push([record[1],record[2],record[3]])
        }
      })
  
      parser.on('error', function(err){
        console.error(err.message)
      })

      const csvurl = "https://docs.google.com/spreadsheets/d/e/2PACX-1vSn7iGyKPUFFi9akm3sWCIr-G5fyuepvj0BKD5yfYczuTygAka01lyouh25Z4xM3VJIh6YN695Egwia/pub?gid=0&single=true&output=csv"
      fetch(csvurl).then((response) => {
        return response.text();
      })
      .then((csvdata) => {
        
        loadMessageData(parser,csvdata)
        parser.end()
        setMessagePool(messages)

        
      })
    }
  },[messagePool,setMessagePool])
  const soundToggle = () => {
    setSoundOn(soundOn ? false : true)
  }

  return (
    <div className="App">
      
      <div className="container">
      
        {messagePool ? displayGameState(gameState) : ""}
          <div id="volumecontrol" onClick={soundToggle}>
        {
          soundOn ?  <VolumeUp /> : <VolumeOff />
        }

      </div>
      </div>
    </div>
  );
}

export default App;
